import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export function initCoursesModalSlider(modal: HTMLElement): void {
  const slider = modal.querySelector('.courses__slider');
  if (!slider) return;

  const slides = slider.querySelectorAll('.swiper-slide');
  const coursesCount = slides.length;

  // Если карточек 1 или меньше — не инициализируем Swiper, добавляем not-swiper
  if (coursesCount <= 1) {
    slider.classList.add('not-swiper');
    slider.classList.remove('swiper');
    return;
  }

  const paginationElement = slider.parentElement?.querySelector('.swiper-pagination') as HTMLElement | null;

  const swiper = new Swiper(slider as HTMLElement, {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 24,
    
    pagination: {
      el: paginationElement,
      clickable: true,
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    loop: false,
    watchOverflow: true,
    breakpoints: {
      0: { slidesPerView: 1 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 3 },
    },
    on: {
      slideChange: function () {
        updateProgressBar(this, modal);
      },
      afterInit: function () {
        updateProgressBar(this, modal);
        maybeRemoveSliderControls(this, modal);
      }
    }
  });

  function updateProgressBar(swiperInstance: any, modalEl: HTMLElement) {
    const indicator = modalEl.querySelector<HTMLElement>('.swiper__indicator__progress');
    if (!indicator) return;
    const totalSlides = swiperInstance.slides.length - swiperInstance.params.slidesPerView + 1;
    const currentIndex = swiperInstance.realIndex || 0;
    const percent = totalSlides > 1 ? (currentIndex / (totalSlides - 1)) * 100 : 0;
    indicator.style.width = percent + '%';
  }

  function maybeRemoveSliderControls(swiperInstance: any, modalEl: HTMLElement) {
    const controls = modalEl.querySelector('.slider-controls');
    if (!controls) return;
    let slidesPerView = swiperInstance.params.slidesPerView;
    if (swiperInstance.slides.length <= slidesPerView) {
      controls.remove();
    }
  }
} 